import ModalExport from '@/components/apps/com/DataExportModal'
import { mapState, mapActions } from 'vuex'
import Api from '@/repositories/api'
import Util from '@/utils/util'

/**
 * 申請書作成画面共通mixin
 */
export default {
  components: { ModalExport },
  data () {
    return {
      nextTicker: true,

      /**
       * edit: 入力画面
       * conf: 確認画面
       * comp: 完了画面
       * ref: 参照画面(不要)
       */
      mode: null,
      subtitle: '',
      titleType: '',

      /**
       * 各申請書で定義したpostData.applicationの後ろにObject.assignする
       */
      postData__application: {
        is_partner: null,
        app_code: '', // 各申請書コンポーネントのcreatedで埋めてください
        order_date: new Date(),
        // ここは使う申請書だけ自分で定義してください
        // order_no: '',
        // estimate_no: '',
        // license_no: '',
        // customer_code: '',
        end_org_name: '',
        end_org_kana: '',
        end_representative_name: '',
        end_representative_kana: '',
        end_dept_name: '',
        end_chrg_name: '',
        end_chrg_kana: '',
        end_tel: '',
        end_fax: '',
        end_zipcode: '',
        end_address: '',
        end_email: '',
        partner_org_name: '',
        partner_org_kana: '',
        partner_representative_name: '',
        partner_representative_kana: '',
        partner_dept_name: '',
        partner_chrg_name: '',
        partner_chrg_kana: '',
        partner_tel: '',
        partner_fax: '',
        partner_zipcode: '',
        partner_address: '',
        partner_email: '',
        notes: ''
      }
    }
  },
  computed: {
    ...mapState([
      'token', // this.token → this.$store.state.token のマッピング
      'app_id', // this.app_id → this.$store.state.app_id のマッピング
      'downloaded' // this.downloaded → this.$store.state.downloaded のマッピング
    ]),
    isEdit () {
      return this.mode === 'edit'
    },
    isConf () {
      return this.mode === 'conf'
    },
    isComp () {
      return this.mode === 'comp'
    }
  },
  watch: {
    mode () {
      // IEはelement.scrollTo()非対応
      document.body.scrollTop = 0
      document.body.scrollLeft = 0
    }
  },
  methods: {
    ...mapActions([
      'saveTokenEtc', // this.saveTokenEtc() → this.$store.dispatch('saveTokenEtc') のマッピング
      'setDownloaded', // this.setDownloaded() → this.$store.dispatch('setDownloaded') のマッピング
    ]),
    isPartnerApp () {
      return this.$route.query.target === 'p'
    },
    isEnduserApp () {
      return this.$route.query.target === 'e'
    },

    getHtml () {
      let head = document.head
      // 参照渡しにならないよう、DOMのコピーを生成
      let main = this.$refs.main.$el.cloneNode(true)

      // DOMを加工する
      this.processDom(main)

      // wkhtmlpdfはlinkを解釈できるようです
      // // CSSをHTMLに埋め込む
      // let links = head.querySelectorAll('link[rel="stylesheet"]')
      // for (let link of links) {
      //   let path = link.getAttribute('href')
      //   this.setCss(path, head)
      // }

      // DOMを文字列に変換する
      return '<!DOCTYPE html><html lang="ja">' + head.outerHTML + '<body>' + main.outerHTML + '</body></html>'
    },
    /**
     * PDF出力用のDOMを加工する
     * @param main
     */
    processDom: function (main) {
      main.classList.add('is-pdf')

      // 不要なDOMを削除
      // 画面タイトルの変更・ボタンバー・注釈・「ページの先頭へ戻る」ボタン
      let nopdfs = main.querySelectorAll('.nopdf')
      for (let elem of nopdfs) {
        elem.parentNode.removeChild(elem)
      }
    },
    /**
     * CSSをHTMLに埋め込む
     * @param path
     * @param head
     */
    setCss: function (path, head) {
      // CSSのURLからファイル内容を取得する
      const XHR = new XMLHttpRequest()
      XHR.open('GET', path, false) // 同期処理
      XHR.send()

      // レスポンスをheadに埋め込む
      const style = document.createElement('style')
      style.setAttribute('type', 'text/css')
      style.textContent = XHR.responseText
      head.appendChild(style)
    },
    /**
     * データインポート：各種申請書共通データの入力チェック
     * @param importData
     * @param postData
     * @returns {boolean}
     */
    adjustImportAppData: function (importData, postData) {
      // 存在・型チェック
      if (importData === null || typeof importData !== 'object') {
        // フォーマットエラー（上書きしない）
        // delete importData
        return false
      }

      // 画面の申請書とインポートした申請書の種類が違う場合
      if (importData.app_code !== postData.app_code || importData.is_partner !== postData.is_partner) {
        // インポート成功時にメッセージを表示する
        this.$notification.open({
          message: '異なる申請書データのファイルが選択されたため、一部のデータのみインポートします。',
          type: 'is-info'
        })
      }

      // 画面がエンドの場合
      if (postData.is_partner === '0') {
        // インポートデータのパートナー情報を削除する
        for (let key in importData) {
          if (key.indexOf('partner_') === 0) {
            delete importData[key]
          }
        }
      }
      // パートナーフラグは上書きしない
      delete importData.is_partner

      // 申請書コード
      if (importData.app_code !== postData.app_code) {
        // // 各種申請書データを削除する（共通データのみインポートする）
        // for (let key in importData) {
        //   if (key !== 'importData') {
        //     delete importData[key]
        //   }
        // }
      }
      // 申請書コードは上書きしない
      importData.app_code = postData.app_code

      // 共通入力チェック
      for (let key in importData) {
        importData[key] = this.adjustImportData(importData[key])
      }

      // 作成日
      importData.order_date = Util.stringToDate(importData.order_date)
      if (!importData.order_date) {
        // フォーマットエラー（上書きしない）
        importData.order_date = postData.order_date
      }

      return true
    },
    adjustImportData (data) {
      // toString()エラー回避
      return data === null ? '' : data.toString()
    },
    /**
     * インポートデータをpostDataにそのまま移し替える
     * @param importData
     * @param postData
     */
    setImportData (importData, postData) {
      for (let key in postData) {
        if (key in importData) {
          postData[key] = importData[key]
        }
      }
    },
    /**
     *
     * @param object options {
     *   {
     *     key: 'neo',
     *     label: 'desknet\'s NEO',
     *     value: 'p'
     *   }
     * }
     * @param string key `neo`等
     * @return string 値
     */
    getOptionValueByKey (options, key) {
      for (let item of options) {
        if (item.key === key) {
          return item.value
        }
      }
      return ''
    },
    /**
     *
     * @param object options {
     *   {
     *     key: 'neo',
     *     label: 'desknet\'s NEO',
     *     value: 'p'
     *   }
     * }
     * @param string value `a`等
     * @return string ラベル名
     */
    getOptionLabelByValue (options, value) {
      for (let item of options) {
        if (item.value === value) {
          return item.label
        }
      }
      return ''
    },
    /**
     *
     * @param object options {
     *   {
     *     key: 'neo',
     *     label: 'desknet\'s NEO',
     *     value: 'p'
     *   }
     * }
     * @param string key `neo`等
     * @return string ラベル名
     */
    getOptionLabelByKey (options, key) {
      for (let item of options) {
        if (item.key === key) {
          return item.label
        }
      }
      return ''
    },
    /**
     *
     * @param object options {
     *   {
     *     key: 'neo',
     *     label: 'desknet\'s NEO',
     *     value: 'p'
     *   }
     * }
     * @param string value
     * @param array selected
     * @return boolean
     */
    isOptionKeySelected (options, key, selected) {
      return Util.isIncludes(selected, this.getOptionValueByKey(options, key))
    },
    /**
     *
     * @param object options {
     *   {
     *     key: 'neo',
     *     label: 'desknet\'s NEO',
     *     value: 'p'
     *   }
     * }
     * @param string value カンマ区切り
     * @return boolean
     */
    isOptionValueValid (options, values) {
      if (values === '') {
        return true
      }
      values = values.split(',')
      // すべての選択肢が適切である場合、trueを返す
      return values.every((value) => {
        for (let item of options) {
          if (item.value === value) {
            return true
          }
        }
        return false
      })
    },
    /**
     * 入力チェックを行う（複数選択項目）
     * @param object options {
     *   {
     *     key: 'neo',
     *     label: 'desknet\'s NEO',
     *     value: 'p'
     *   }
     * }
     * @param string value チェック対象の文字列（カンマ区切り）
     * @return string チェック済みの文字列（カンマ区切り）
     */
    isMultiOptionValueValid (options, values) {
      // 規定値以外の値
      let arException = []

      // カンマ区切りの文字列を配列化する
      values = values.split(',')

      // 規定値に含まれているかチェックする
      for (let index in values) {
        // 初期化：有効フラグ
        let isValid = false

        for (let item of options) {
          // 規定値に含まれている場合、有効
          if (item.value === values[index]) {
            isValid = true
            break
          }
        }

        // 規定値に含まれていない場合、無効
        if (!isValid) {
          arException.push(values[index])
        }
      }

      // 無効な要素を配列から取り除く
      values = values.filter(item => arException.indexOf(item) === -1)

      // 入力チェック済みの文字列を返す
      return values.join()
    },

    /**
     *
     */
    downloadDataFile () {
      this.$modal.open({
        parent: this.$parent,
        component: ModalExport,
        props: {
          app_id: `${this.postData.application.app_code}-draft-${+new Date()}`,
          data: this.app_getSubmitData()
        },
        hasModalCard: true
      })
    },
    /**
     * データインポート処理
     * @param file
     * @returns {boolean}
     */
    importData (file) {
      this.appErrorMessage = ''
      this.appInfoMessage = ''

      // ファイル読み込み
      Util
        .readFile(file)
        .then((contents) => {
          this._checkMetaData(contents)

          // インポート用データ
          let data = contents.data || {}
          // 申請書共通データ
          let importAppData = data.application || {}
          // 申請書個別データ
          delete data.application
          let importMyData = data

          // 申請書共通データ
          // 入力チェック
          if (!this.adjustImportAppData(importAppData, this.postData.application)) {
            importAppData = {}
          }
          // データセット
          this.setImportData(importAppData, this.postData.application)

          // 申請書個別データ
          // 入力チェック
          this._adjustImportMyData(importMyData)
          // データセット
          this.app_setImportData(importMyData)

          // 画面に反映させるために、子コンポーネントをリロードする
          this.nextTicker = false
          this.$nextTick(() => {
            this.nextTicker = true
          })

          this.$notification.open({
            message: 'データのインポートが完了しました。',
            type: 'is-success'
          })
        })
        .catch((e) => {
          this.$notification.open({
            message: e.message,
            type: 'is-danger'
          })
        })
    },
    /**
     * メタデータチェック
     * @param contents
     * @private
     */
    _checkMetaData (contents) {
      if (contents.version !== process.env.API_VERSION) {
        this.$notification.open({
          message: 'インポートしたファイルのバージョンが古いため、インポートできないデータがあるかもしれません。',
          type: 'is-info'
        })
      }
    },
    /**
     * データインポート：申請書データの入力チェック
     * @param importData
     * @private
     */
    _adjustImportMyData (importData) {
      const optionFields = Object.keys(this.options)
      for (let field in importData) {
        // フィールドを調整する
        importData[field] = this.adjustImportData(importData[field])
        if (Util.isIncludes(optionFields, field)) {
          // 選択肢フィールドを調整する
          if (!this.isOptionValueValid(this.options[field], importData[field])) {
            // 選択肢以外の値が入力された場合はクリアする
            if (field === 'editions' || field === 'categories' || field === 'change_target') {
              // 複数選択の場合、有効な値のみ受け入れる
              importData[field] = this.isMultiOptionValueValid(this.options[field], importData[field])
            } else {
              importData[field] = null // nullにしないと、placeholderが出ない
            }
          }
        }
      }
    },

    /**
     * PDF作成ボタンで呼ばれる処理
     * form(@submit.prevent="submit")
     */
    submit: function () {
      this.appErrorMessage = ''
      if (this.isEdit) {
        // 入力チェックに通れば、確認画面に進む
        if (this.app_validationCheck()) {
          this.mode = 'conf'
        }
      } else {
        // PDF作成処理に進む
        this._post()
      }
    },

    /**
     * API実行
     */
    _post () {
      const ApplicationsApi = Api.get('applications')
      const submitData = this.app_getSubmitData()
      const html = this.getHtml()

      // サブミットボタンをロックする
      this.toggleSubmitButtons(true)

      ApplicationsApi
        .post(submitData.application.app_code, {data: submitData, html: html})
        .then(({ data }) => {
          // サブミットボタンのロックを解除する
          this.toggleSubmitButtons(false)

          this.saveTokenEtc({token: data.data.token, app_id: data.data.app_id})
          // 完了画面へ進む
          this.$router.push({name: 'Saved', query: this.$route.query})
        })
        .catch((e) => {
          // サブミットボタンのロックを解除する
          this.toggleSubmitButtons(false)

          const _errors = this.fetchErrorMessages(e)
          this.appErrorMessage = _errors.join('\n') // TODO
          // 入力画面へ戻る
          this.mode = 'edit'
        })
    },

    /**
     * サブミットボタンのロック/ロック解除
     * @param {boolean} lock
     */
    toggleSubmitButtons (lock) {
      const buttons = document.querySelectorAll('.button-bar .button')
      for (let button of buttons) {
        // 元々`disabled`のボタンは対象外とする
        if (lock && !button.disabled) {
          button.disabled = true
        } else {
          button.disabled = false
        }
      }
    },

    /**
     * postDataをAPI送信用に変換する（共通処理）
     * @returns {any}
     */
    getSubmitData () {
      let order_date = this.postData.application.order_date
      let submitData = JSON.parse(JSON.stringify(this.postData))

      submitData.application.order_date = Util.dateToString(order_date)

      return submitData
    },

    // ↓↓↓各申請書コンポーネントでの上書き用↓↓↓

    /**
     * postDataをAPI送信用に変換する（上書き用）
     * @returns {*|any}
     */
    app_getSubmitData () {
      // 共通処理
      return this.getSubmitData()
    },

    /**
     * postDataをチェックした結果を返す（上書き用）
     * @returns {boolean}
     */
    app_validationCheck () {
      return true
    },

    /**
     * インポートデータをpostDataに変換する（上書き用）
     * @param importData
     */
    app_setImportData (importData) {
      // 共通処理
      this.setImportData(importData, this.postData)
    }
  },
  created () {
    this.titleType = this.isPartnerApp() ? 'is-light' : 'is-light' // draft
    this.postData__application.is_partner = this.isPartnerApp() ? '1' : '0'

    // tokenクリアすると、完了画面からブラウザバックでundo→redoしたときに、PDFダウンロードできなくなるので
    // tokenクリアせずに残しておくことにする
    // // tokenクリア（各申請書のcreatedでmodeが更新されるのを待ちたい）
    // let count = 0
    // const interval = setInterval(() => {
    //   count++
    //   if (this.mode) {
    //     if (this.isEdit) {
    //       console.log('cleared')
    //       this.setToken(null)
    //     }
    //     clearInterval(interval)
    //     return
    //   }
    //   if (count > 200) {
    //     console.error('@/mixins/applicationを読んだ場合は、modeを設定してください。')
    //     clearInterval(interval)
    //   }
    // }, 200)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/application.js